import { __isKnytReference, ensureReference, OBSERVABLE_PROPERTY_NAME, } from "@knyt/artisan";
import { hold } from "../hold.js";
import { ContextRequestEvent } from "./events.js";
export class BaseConsumer {
    #state;
    #dispatcher$;
    #subscription = null;
    constructor(host, { initialValue, target: dispatcher, onUpdate, }) {
        this.#state = hold(host, initialValue, onUpdate);
        this.#dispatcher$ = ensureReference(dispatcher);
        host.addController(this);
    }
    subscribe(subscriber) {
        return this.#state.subscribe(subscriber);
    }
    hostConnected() {
        this.#setup();
    }
    hostDisconnected() {
        this.#teardown();
    }
    async #handleSubscription(sub) {
        try {
            this.#subscription = await sub;
        }
        catch (error) {
            console.error(error);
        }
    }
    #resubscribe() {
        this.#teardown();
        this.#setup();
    }
    #setup() {
        const handleValueUpdate = (value) => {
            this.#state.set(value);
        };
        const contextRequest = new ContextRequestEvent({
            contextKey: this._contextKey,
            handleValueUpdate,
            resubscribe: () => this.#resubscribe(),
        });
        this.#handleSubscription(contextRequest.subscription.promise);
        this.#dispatcher$.value?.dispatchEvent(contextRequest);
    }
    #teardown() {
        this.#subscription?.unsubscribe();
        this.#subscription = null;
    }
    get value() {
        return this.#state.get();
    }
    get = () => {
        return this.#state.get();
    };
    [__isKnytReference] = true;
    asInterop() {
        return this.#state.asInterop();
    }
    [Symbol.observable]() {
        return this.asInterop();
    }
    [OBSERVABLE_PROPERTY_NAME]() {
        return this.asInterop();
    }
}
